import { gql } from "@shane32/graphql";

export const ZipCodeTemplateQuery = gql`
    {
        v1 {
            info {
                zipCodeTemplate
            }
        }
    }
`;

export interface IZipCodeTemplateQuery {
    v1: {
        info: {
            zipCodeTemplate: string;
        };
    };
}
